import React from "react";

export default function ErrorPage() {
  return (
    <div>
      <h1>Oops! Something went wrong.</h1>
      <h2>The page was not found.</h2>
      <text>It may be in development. Please try again later!</text>
    </div>
  );
}
